<template>
  <tr style="cursor: pointer" @click="showDetail = true">
    <td>
      <v-btn outline fab small class="extra-small">
        <em class="fas fa-align-left" />
      </v-btn>
      <v-dialog v-model="showDetail" max-width="800">
        <v-card v-if="showDetail">
          <v-card-text>
            <div class="text-xs-right">
              <v-btn flat small fab class="ma-0" @click="showDetail = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>

            <div>
              <v-avatar>
                <img
                  :src="value.photourl || '/static/img/assets/livechat/profile.png'"
                  @error="onError"
                />
              </v-avatar>
            </div>

            <h4 class="primary--text">
              {{ `${value.title} ${value.first_name} ${value.last_name}` }}
            </h4>
            <v-layout wrap class="mb-3">
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Nationality</div>
                {{ value.nationality ? value.nationality : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Date of Birth</div>
                {{ value.dob ? value.dob : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Phoneno</div>
                {{ value.phoneno ? value.phoneno : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Lineid</div>
                {{ value.lineid ? value.lineid : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Email</div>
                {{ value.email ? value.email : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Interest</div>
                {{ value.interest ? value.interest : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Source</div>
                <template v-if="value.urlsource == 'diyresume'">DIY Resume</template>
                <template v-else-if="value.urlsource == 'event'">Event</template>
                <template v-else>-</template>
              </v-flex>

              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Country</div>
                {{ value.country ? value.country : '-' }}
              </v-flex>
              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Province</div>
                {{ value.province ? value.province : '-' }}
              </v-flex>

              <v-flex xs12 sm6 class="mt-1 mb-2">
                <div class="caption grey--text">Address</div>
                {{ value.addresstext ? value.addresstext : '-' }}
              </v-flex>
            </v-layout>

            <template v-if="experiences && experiences.length > 0">
              <div class="title my-3 primary--text">Experience</div>
              <v-card>
                <v-card-text>
                  <template v-for="(experience, index) in experiences">
                    <div :key="'exp_' + index" class="pa-2">
                      <strong>{{ experience.companyname }}</strong>
                      <div>{{ experience.position }}</div>
                      <div class="caption grey--text">{{ experience.responsibility }}</div>
                      <div>
                        {{
                          `${experience.startdate} - ${
                            experience.enddate && !experience.iscurrent
                              ? experience.enddate
                              : 'Present'
                          }`
                        }}
                      </div>
                    </div>
                    <v-divider :key="'divider_' + index" v-if="experiences.length - 1 != index" />
                  </template>
                </v-card-text>
              </v-card>
            </template>

            <template v-if="educations && educations.length > 0">
              <div class="title my-3 primary--text">Education</div>
              <v-card>
                <v-card-text>
                  <template v-for="(education, index) in educations">
                    <div :key="'edu_' + index" class="pa-2">
                      <strong>{{ education.degree }}</strong>
                      <div>
                        {{
                          `${education.institution} ${
                            education.country ? `(${education.country})` : ''
                          }`
                        }}
                      </div>
                      <div class="caption grey--text">
                        {{
                          `${education.faculty ? `${education.faculty}` : ''} ${
                            education.major ? `${education.major}` : ''
                          } ${education.gpa ? `GPA ${education.gpa}` : ''}`
                        }}
                      </div>
                      <div>
                        {{
                          `${education.startdate} - ${
                            education.enddate ? education.enddate : 'Present'
                          }`
                        }}
                      </div>
                    </div>
                    <v-divider :key="'divider_' + index" v-if="educations.length - 1 != index" />
                  </template>
                </v-card-text>
              </v-card>
            </template>

            <template v-if="languages && languages.length > 0">
              <div class="title my-3 primary--text">Language</div>
              <v-card>
                <v-card-text>
                  <template v-for="(lang, index) in languages">
                    <div class="pa-2" :key="'lang_' + index">
                      <v-layout>
                        <v-flex>{{ `${lang.lang} ${lang.type ? `(${lang.type})` : ''}` }}</v-flex>
                        <v-flex class="text-xs-right">{{ lang.score }}</v-flex>
                      </v-layout>
                    </div>
                    <v-divider :key="'divider_' + index" v-if="languages.length - 1 != index" />
                  </template>
                </v-card-text>
              </v-card>
            </template>

            <template v-if="skills && skills.length > 0">
              <div class="title my-3 primary--text">Other Skills</div>
              <v-card>
                <v-card-text>
                  <template v-for="(skill, index) in skills">
                    <div class="pa-2" :key="'skill_' + index">
                      <v-layout>
                        <v-flex>{{
                          `${skill.category} ${skill.skill ? `(${skill.skill})` : ''}`
                        }}</v-flex>
                        <v-flex class="text-xs-right">{{ skill.level }}</v-flex>
                      </v-layout>
                    </div>
                    <v-divider :key="'divider_' + index" v-if="skills.length - 1 != index" />
                  </template>
                </v-card-text>
              </v-card>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </td>
    <td>
      <v-avatar>
        <img :src="value.photourl || '/static/img/assets/livechat/profile.png'" @error="onError" />
      </v-avatar>
    </td>
    <td>{{ `${value.title} ${value.first_name} ${value.last_name}` }}</td>
    <td style="white-space: nowrap">
      <template v-for="(education, index) in educations">
        <div :key="'edu_' + index" class="pa-2">
          <strong>{{ education.degree }}</strong>
          <div>
            {{ `${education.institution} ${education.country ? `(${education.country})` : ''}` }}
          </div>
          <div class="caption grey--text">
            {{
              `${education.faculty ? `${education.faculty}` : ''} ${
                education.major ? `${education.major}` : ''
              } ${education.gpa ? `GPA ${education.gpa}` : ''}`
            }}
          </div>
          <div>
            {{ `${education.startdate} - ${education.enddate ? education.enddate : 'Present'}` }}
          </div>
        </div>
        <v-divider :key="'divider_' + index" v-if="educations.length - 1 != index" />
      </template>
    </td>
    <td>{{ value.phoneno }}</td>
    <td>{{ value.lineid }}</td>
    <td>{{ value.email }}</td>
    <td>{{ value.interest }}</td>
    <td>
      <template v-if="value.urlsource == 'diyresume'">DIY Resume</template>
      <template v-else-if="value.urlsource == 'event'">Event</template>
      <template v-else>-</template>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      showDetail: false,
      experiences: [],
      educations: [],
      languages: [],
      skills: []
    }
  },
  mounted() {
    if (this.value) {
      this.experiences = JSON.parse(this.value.experiencejson)
      this.educations = JSON.parse(this.value.educationjson)
      this.languages = JSON.parse(this.value.languagejson)
      this.skills = JSON.parse(this.value.skilljson)
    }
  },
  methods: {
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/scgcareer/Applicant.vue